export class Rotas {

    public static VOUCHER_CONFIRMAR = 'voucher/confirmar';
    public static VOUCHER_RESGATAR = 'voucher/resgatar';
    public static VOUCHER_DADOS_TRANSFERENCIA = 'voucher/dados-transferencia';
    public static VOUCHER_SUCESSO = 'voucher/sucesso';

}



// WEBPACK FOOTER //
// ./src/app/resources/classes/rotas.ts